import { Link } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import EventAvailableOutlined from '@material-ui/icons/EventAvailableOutlined';
import { Rating } from '@material-ui/lab';
import { SmallSectionHeader } from 'components/Typography';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { GOOGLE_MAPS } from 'utils/globalConst';
import labels from 'utils/labels';
import {
  LocationIcon,
  PhoneIcon,
  StyledAddress,
  StyledButton,
  StyledCaptions,
} from './styles';

interface IDoctor {
  fullName?: string;
  rating?: number;
  address?: string;
  hasOnlineAgenda?: boolean;
  phoneNumber?: string;
  specialities?: string[];
  profileUrl?: string;
  location?: {
    latitude: number;
    longitude: number;
  };
}

interface IProps {
  intl: IntlShape;
  doctor: IDoctor;
}

const Doctor = ({ doctor, ...props }: IProps) => {
  const {
    fullName = '',
    address = '',
    hasOnlineAgenda = false,
    specialities = [],
    rating = 0,
    phoneNumber = '',
    location = {
      latitude: 0,
      longitude: 0,
    },
    profileUrl = '',
  } = doctor;

  return (
    <Box pr={3} py={2.5}>
      <Grid container>
        <Grid item xs={9} justify="flex-start">
          <SmallSectionHeader weight="500">{fullName}</SmallSectionHeader>
          <StyledCaptions weight="400">
            {specialities?.join(', ')}
          </StyledCaptions>
          {!!rating && (
            <Grid>
              <Rating
                size="small"
                value={rating}
                readOnly
                max={Math.ceil(rating)}
              />
            </Grid>
          )}
          <StyledAddress weight="100">{address}</StyledAddress>
          {hasOnlineAgenda && (
            <Link href={profileUrl}>
              <StyledButton
                variant="contained"
                startIcon={<EventAvailableOutlined />}
              >
                {translate({ id: labels.makeAppointment }, props)}
              </StyledButton>
            </Link>
          )}
        </Grid>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="flex-end"
          xs={3}
        >
          {phoneNumber && (
            <Link href={`tel:${phoneNumber}`}>
              <PhoneIcon />
            </Link>
          )}
          <Link
            href={`${GOOGLE_MAPS}?q=${location.latitude},${location.longitude}`}
          >
            <LocationIcon />
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};

export default injectIntl(Doctor);
